import kokoro_1 from './kokoro-1.png';
import kokoro_2 from './kokoro-2.png';
import kokoro_3 from './kokoro-3.png';
import kokoro_4 from './kokoro-4.png';
import kokoro_5 from './kokoro-5.png';
import kokoro_6 from './kokoro-6.png';
import password_manager_1 from './password-manager-1.png';
import password_manager_2 from './password-manager-2.png';
import password_manager_3 from './password-manager-3.png';
import password_manager_4 from './password-manager-4.png';
import tesla_now_1 from './tesla-now-1.png';
import tesla_now_2 from './tesla-now-2.png';
import tesla_now_3 from './tesla-now-3.png';
import tesla_now_4 from './tesla-now-4.png';
import tesla_now_5 from './tesla-now-5.png';
import nss_1 from './nss-1.png';
import nss_2 from './nss-2.png';
import nss_3 from './nss-3.png';
import nss_4 from './nss-4.png';
import nss_5 from './nss-5.png';
import portfolio_1 from './portfolio-1.png';
import portfolio_2 from './portfolio-2.png';
import portfolio_3 from './portfolio-3.png';
import portfolio_4 from './portfolio-4.png';

// feel free to remove images if load is too high

const images = {
  kokoro: [
    kokoro_1,
    kokoro_2,
    kokoro_3,
    kokoro_4,
    kokoro_5,
    kokoro_6
  ],
  password_manager: [
    password_manager_1,
    password_manager_2,
    password_manager_3,
    password_manager_4
  ],
  tesla_now: [
    tesla_now_1,
    tesla_now_2,
    tesla_now_3,
    tesla_now_4,
    tesla_now_5
  ],
  nss: [
    nss_1,
    nss_2,
    nss_3,
    nss_5,
    nss_4
  ],
  portfolio: [
    portfolio_1,
    portfolio_2,
    portfolio_3,
    portfolio_4
  ]
}

export default images;